import { IIconProps } from "../types"

export default function IconUR2(props: IIconProps) {
  const width = props.size || props.width || (83 / 5) * 3
  const height = props.size || props.height || (115 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 83 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.1 0.533852C45.6791 0.743785 48.3883 1.3336 50.8375 2.69316C53.2967 4.04273 55.486 6.16205 57.5253 8.87118C59.5547 11.5703 61.4141 14.8693 64.923 25.8357C68.4418 36.7922 73.6002 55.4063 76.5992 67.3324C79.6083 79.2686 80.458 84.5169 81.0478 88.9155C81.6376 93.3141 81.9775 96.873 81.5576 99.912C81.1278 102.961 79.9482 105.5 78.2587 107.49C76.5592 109.479 74.36 110.918 70.981 111.888C67.5921 112.858 63.0236 113.368 55.7459 113.578C48.4683 113.788 38.4815 113.708 31.1638 113.068C23.8461 112.438 19.1876 111.248 15.3889 109.769C11.5801 108.289 8.61103 106.51 6.50171 104.401C4.38239 102.281 3.11279 99.832 2.22308 97.7127C1.33336 95.6034 0.833525 93.8239 0.573608 91.5347C0.323689 89.2554 0.323688 86.4563 1.80321 78.2489C3.28274 70.0416 6.24179 56.4259 9.42077 45.0796C12.5898 33.7432 15.9787 24.6861 19.1077 18.2582C22.2367 11.8302 25.1157 8.02145 27.8249 5.52225C30.534 3.02305 33.0632 1.84343 35.5624 1.16365C38.0616 0.493865 40.5108 0.323919 43.1 0.533852Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
